import { Injectable } from '@angular/core';

import {
   HttpInterceptor,
   HttpRequest,
   HttpHeaders,
   HttpHandler,
   HttpEvent,
   HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { Observable, of, timer, throwError } from 'rxjs';
import {
   map,
   switchMap,
   retry,
   takeUntil,
} from 'rxjs/operators';

import { isAssets, isFullUrl } from './httpFunctions';
import { HttpCancelService } from './http-cancel.service';

@Injectable()
export class RadiantHttpInterceptor implements HttpInterceptor {
   constructor(
      private cancelService: HttpCancelService,
   ) { }

   retries = new Map<string, any>();

   intercept(
      request: HttpRequest<any>,
      next: HttpHandler,
   ): Observable<HttpEvent<any>> {
      if ( isAssets( request.url )) {
         return next.handle( request );
      }
      if ( isFullUrl( request.url )) {
         return next.handle( request );
      }
      // console.log( 'original request', request );

      // middleware request
      return this.headers( request ).pipe(
         takeUntil( this.cancelService.cancelAll ),
         map( headers => request.clone({
            url: ((request.params.get('useLambda') && this.lambda()) || request.params.get('useLocalLambda') && this.localLambda() || this.origin()) + request.url,
            headers
         })),
         switchMap( customReq => {
            // console.log( 'intercepted request', customReq );

            customReq = customReq.clone({
               params: customReq.params.delete('useLambda').delete('useLocalLambda'),
            });

            return next.handle( customReq ).pipe(
               retry({
                  count: 2,
                  delay: ( error, retryCount ) => {
                     const isPaginated = !!customReq.body?.pagination;

                     if (
                        customReq.method !== 'GET' || // only retry on GET
                        isPaginated || // do not retry paginated requests
                        !error.status || // unexpected status
                        error.status.toString().startsWith( '4' ) // no retry on 4**
                     ) {
                        return throwError( () => error );
                     }

                     return timer( 1000 * retryCount );
                  },
               }),
            );
         })
      );
   }

   /** Override to set the middleware server URL */
   origin(): string {
      return '';
   }

   lambda(): string {
      return '';
   }

   localLambda(): string {
      return '';
   }

   /** Override to set request headers ( ie build version ) */
   headers( request: HttpRequest<any> ): Observable<HttpHeaders> {
      return of( request.headers );
   }

   reset() {
      this.cancelService.cancelPendingRequests();
   }
}

export let httpInterceptor2 = {
   provide: HTTP_INTERCEPTORS,
   useClass: RadiantHttpInterceptor,
   multi: true
};
